import React, { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { useIssueCreateSidePanelContext } from './providers/IssueCreateSidePanelContextProvider';
import { RainbowLoadingSidebar } from './RainbowLoadingSidebar';

type IssueCreateAiLoadingSidebarProps = {
	children: React.ReactNode;
};

export const IssueCreateAiLoadingSidebar = ({ children }: IssueCreateAiLoadingSidebarProps) => {
	const [{ aiState }] = useIssueCreateSidePanelContext();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const isAiLoading = aiState === 'loading';

	useEffect(() => {
		if (isAiLoading) {
			createAnalyticsEvent({
				type: 'sendScreenEvent',
				data: {
					name: 'AI loading state',
					source: 'confluenceHighlightIssueCreate',
				},
			}).fire();
		}
	}, [createAnalyticsEvent, isAiLoading]);

	return <RainbowLoadingSidebar isShown={isAiLoading}>{children}</RainbowLoadingSidebar>;
};
